import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.md};
  border: solid ${pxToRem(1)} ${theme.semantic.border.default};
  box-shadow: ${theme.dropShadow[100]};
`;
